export default __webpack_public_path__ + "static/media/yanchenko.ec6511e5.png";